/**
 * Strips all markdown and visual-only content (charts, maps, tables, code)
 * before passing text to any TTS engine.
 */
export function cleanForTTS(text) {
  return text
    .replace(/```map[\s\S]*?```/gi, '')      // map blocks
    .replace(/```[\s\S]*?```/g, '')          // all code blocks
    .replace(/^\|.*$/gm, '')                 // markdown table rows
    .replace(/`[^`]+`/g, '')                 // inline code
    .replace(/^#{1,6}\s+/gm, '')             // headers
    .replace(/\*\*\*([^*]+)\*\*\*/g, '$1')  // bold+italic
    .replace(/\*\*([^*]+)\*\*/g, '$1')      // bold
    .replace(/\*([^*]+)\*/g, '$1')          // italic
    .replace(/__([^_]+)__/g, '$1')          // bold underscore
    .replace(/_([^_]+)_/g, '$1')            // italic underscore
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // links → label only
    .replace(/!\[[^\]]*\]\([^)]+\)/g, '')   // images
    .replace(/https?:\/\/\S+/g, '')         // bare URLs
    .replace(/[#*`~_>|]/g, '')              // leftover markdown chars
    .replace(/\n{2,}/g, '. ')
    .replace(/\n/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();
}
